// @ts-nocheck
// Call Stats — the Today / Yesterday / This Week row.
//
// Owns which card is expanded, because expanding one animates the others:
// the expanded card's flex-grow goes to 1 while its siblings animate to
// flex-grow 0 + opacity 0, so the breakdown appears to slide open sideways
// into the space they vacate (Today opens toward Yesterday/This Week, This
// Week opens back across Yesterday/Today). Replaces the old behaviour, where
// the breakdown pushed the page down — and before that, rendered in a
// detached block near the top of the page entirely.
//
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import PeriodOverviewCard from './PeriodOverviewCard';
import { getChartColors } from './colors';

const SPRING = { type: 'spring', stiffness: 260, damping: 30 };

export default function PeriodOverviewRow({ periodCards, isDark, onChartClick, activeKey, loading = false }: any) {
  const [expandedKey, setExpandedKey] = useState(null);
  const { periodAccents } = getChartColors(isDark);

  return (
    <div className="flex flex-col gap-3 sm:flex-row">
      {periodCards.map((period) => {
        const isExpanded = expandedKey === period.key;
        const isHidden = Boolean(expandedKey) && !isExpanded;

        return (
          <motion.div
            key={period.key}
            layout
            transition={SPRING}
            animate={{ opacity: isHidden ? 0 : 1 }}
            style={{ flexGrow: isHidden ? 0 : 1, flexBasis: 0, minWidth: 0 }}
            className={isHidden ? 'pointer-events-none overflow-hidden' : ''}
            aria-hidden={isHidden}
          >
            <PeriodOverviewCard
              period={period}
              isDark={isDark}
              accent={periodAccents[period.key] || periodAccents.today}
              onChartClick={onChartClick}
              isActive={activeKey === period.key}
              expanded={isExpanded}
              onToggleExpanded={() => setExpandedKey(isExpanded ? null : period.key)}
              loading={loading}
            />
          </motion.div>
        );
      })}
    </div>
  );
}
